import { useEffect, useRef } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
	SEGMENT_EVENTS,
	segmentCondition,
	segmentPayloads,
} from "assets/js/const/SegmentEvents";
import { isMobile } from "react-device-detect";
import fetchRoute from "utils/routes";
import { getUtmCookies, preparePlausibleUrl } from "utils/urlUtils";
import { posthog } from "posthog-js";

const GenericWrapper = (props) => {
	const previous = useRef(window.location.href);
	useEffect(() => {
		/*if (typeof plausible !== "undefined") {
			plausible('pageview', { u: preparePlausibleUrl(), r : document.referrer });
		}*/
		let listen = () => {};
		if (!props.segmentDisabledEvent?.includes(SEGMENT_EVENTS.PAGE)) {
			listen = props.history.listen((location) => {
				if (
					!location.hash.includes(fetchRoute("listRedirections")) &&
					segmentCondition(SEGMENT_EVENTS.PAGE)
				) {
					// eslint-disable-next-line no-undef
					let href = window.location.href;
					let hash = location.pathname;
					if (href.includes("confirm-password")) {
						href = href.substr(0, href.lastIndexOf("/"));
						hash = hash.substr(0, hash.lastIndexOf("/"));
					}
					if (previous.current.includes("confirm-password")) {
						previous.current = previous.current.substr(
							0,
							previous.current.lastIndexOf("/")
						);
					}

					analytics.page(
						segmentPayloads(SEGMENT_EVENTS.PAGE, {
							path: hash,
							url: href,
							search: window.location.search + location.search,
							referrer: previous.current,
						})
					);
				}

				/*if (typeof plausible !== "undefined") {
					plausible('pageview', { u: preparePlausibleUrl() });
				}*/

				previous.current = window.location.href;
			});
		}

		if (isMobile) {
			document.body.className += " mobile";
		}

		return () => {
			listen();
		};
	}, []);
	const previousLocation = useRef();
	useEffect(() => {
		const {
			location: { hash },
		} = props;

		if (hash !== previousLocation.current) {
			if (window?.Appcues) window.Appcues.page();
			previousLocation.current = hash;
		}
	});

	return props.children;
};

export default withRouter(
	connect(
		(state) => {
			return {
				segmentDisabledEvent:
					state.brand?.client_config?.segment_config?.disabled_events,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(GenericWrapper)
);
